import React from "react";
import { getStaticAssetURL } from "@lib/getStaticAssetURL";

export const CustomFontFaces = () => (
  <style jsx global>
    {`
      @font-face {
        src: url(${getStaticAssetURL("/fonts/CitroenTypeRegular.woff2")})
            format("woff2"),
          url(${getStaticAssetURL("/fonts/CitroenTypeRegular.woff")})
            format("woff");
        font-family: CitroenType;
        font-weight: 400;
      }

      @font-face {
        src: url(${getStaticAssetURL("/fonts/CitroenTypeBold.woff2")})
            format("woff2"),
          url(${getStaticAssetURL("/fonts/CitroenTypeBold.woff")})
            format("woff");
        font-family: CitroenType;
        font-weight: 600;
      }

      @font-face {
        src: url(${getStaticAssetURL("/fonts/CitroenTypeBlack.woff2")})
            format("woff2"),
          url(${getStaticAssetURL("/fonts/CitroenTypeBlack.woff")})
            format("woff");
        font-family: CitroenType;
        font-weight: 800;
      }
    `}
  </style>
);
